import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setOpenedDropdownMenuReducer = (state: AppState, action: PayloadAction<string | undefined>) => {
  state.openedDropdownMenu = action.payload;
};

export default setOpenedDropdownMenuReducer;
